var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { searchApi, } from 'apis/search';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { SearchResultsEmpty } from './components/empty/searchResultsEmpty';
import { SearchResultsLoading } from './components/loading/searchResultsLoading';
import { ContactsResults } from './components/types/contacts/contactsResults';
import { ConversationsResults } from './components/types/conversations/conversationsResults';
import { NotesResults } from './components/types/notes/notesResults';
import styles from './searchResults.module.scss';
export const SearchResults = ({ type }) => {
    const { params } = useAppSelector((state) => state.search);
    const { results, isFetching } = searchApi.endpoints.readAdvancedSearchResults.useQueryState({
        type,
        params,
    }, {
        selectFromResult: (_a) => {
            var { data } = _a, rest = __rest(_a, ["data"]);
            return (Object.assign(Object.assign({}, rest), { results: data === null || data === void 0 ? void 0 : data.data.results }));
        },
    });
    if (!(results === null || results === void 0 ? void 0 : results.length))
        return _jsx(SearchResultsEmpty, {});
    return (_jsxs("div", Object.assign({ className: styles.root }, { children: [isFetching && _jsx(SearchResultsLoading, { isOverlay: true }), type === 'conversations' && (_jsx(ConversationsResults, { result: results.find(({ hits_type }) => hits_type === 'conversation') })), type === 'notes' && (_jsx(NotesResults, { result: results.find(({ hits_type }) => hits_type === 'conversation_wrapup') })), type === 'contacts' && (_jsx(ContactsResults, { result: {
                    user: results.find(({ hits_type }) => hits_type === 'user'),
                    company: results.find(({ hits_type }) => hits_type === 'company'),
                } }))] })));
};
